import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import MenuForm from "./MenuForm";
import { createMenu, fetchMenuFlatList } from "../../../services/menuApi";
import { usePermission } from "../../../hooks/usePermission";

export default function AddMenu() {
  const navigate = useNavigate();
  const canManage = usePermission("role", "update");
  const [parents, setParents] = useState([]);

  useEffect(() => {
    fetchMenuFlatList().then(setParents).catch(() => setParents([]));
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      if (!canManage) throw new Error("You do not have permission to add menu.");
      await createMenu({
        name: values.name,
        key: values.key,
        path: values.path,
        icon: values.icon,
        parentId: values.parentId || null,
        order: Number(values.order || 0),
        isActive: Boolean(values.isActive),
      });
      await Swal.fire({ icon: "success", title: "Menu Created", text: "Menu saved successfully." });
      resetForm();
      navigate("/menu-list");
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err.message || "Failed to create menu." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-9">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Menu</h4>
            </div>
            <div className="card-body">
              <MenuForm
                parentOptions={parents}
                onSubmit={handleSubmit}
                onCancel={() => navigate("/menu-list")}
                submitLabel="Create Menu"
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
